var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"streamers-view",attrs:{"fluid":""}},[_c('h1',{staticClass:"text-h5 font-weight-medium mb-2"},[_vm._v("Streamers")]),_c('CopyStakeStreamerDisclaimer'),_c('CopyStakeStreamersTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }